import { AvatarList } from '@calendly/ui/components/avatar-list';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { FullStoryExclude } from '../../shared/fullstory_privacy';
const avatarListWrapperDisabledCss = "aw8iqii";
const avatarListWrapperCss = "aobzhze";
const AvatarListWrapper = forwardRef((props, ref) => {
  const {
    disabled,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(avatarListWrapperCss, {
    [avatarListWrapperDisabledCss]: disabled
  }, props.className)} />;
});
const AVATAR_LIST_SIZE_LIMIT = 5;
const AVATAR_LIST_SIZE_LIMIT_MOBILE = 4;
export const AvatarListSection = ({
  active,
  profiles = []
}) => <AvatarListWrapper disabled={!active}>
    <FullStoryExclude>
      <AvatarList overlapped size="small" mobileLimit={AVATAR_LIST_SIZE_LIMIT_MOBILE} limit={AVATAR_LIST_SIZE_LIMIT} profiles={profiles} />
    </FullStoryExclude>
  </AvatarListWrapper>;

require("./avatar_list_section.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./avatar_list_section.js");